import Vue from 'vue'
import App from './App.vue'
import VueMoment from 'vue-moment'
import model from './model'
import router from './router'
import store from './store'
import 'typeface-montserrat'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faServer, faCircleNotch, faHome, faMapMarker, faUtensils, faClock, faConciergeBell, faMapMarked, faPhone, faEnvelope, faCode, faBars, faArrowLeft, faTimes } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import AsyncComputed from 'vue-async-computed'
import DirectusVue from '@/directus/DirectusVue.js'

library.add(faServer, faCircleNotch, faHome, faMapMarker, faUtensils, faClock, faConciergeBell, faMapMarked, faPhone, faEnvelope, faCode, faBars, faArrowLeft, faTimes)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueMoment)
Vue.use(AsyncComputed)
Vue.use(DirectusVue, {
  endpoint: '/api',
  collections: model,
})

Vue.component('font-awesome-layers', FontAwesomeLayers)

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
